import React from 'react';
import PropTypes from 'prop-types';
import SelectType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";

const SelectField = ({label, menu, path, setValue, values, disabled}) => {
    return (
        <SelectType
            values={values}
            field={{
                values: menu,
                type: "objSelect",
                optLabel: "label",
                disabled,
                path,
                label
            }}
            labelStyles={{width: 100}}
            fieldStyles={{width: 220}}
            setValue={setValue}
        />
    )
};

SelectField.propTypes = {
    label: PropTypes.string,
    menu: PropTypes.array,
    path: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object
};

export default SelectField;